import React, { ChangeEvent } from "react";

import { Input, FormControl } from "kanopi-components/Input";

import { WidthContainer } from "../../ChatFlow/WidthContainer";

interface AbnInputProps {
  label?: string;
  title?: string;
  help?: string;
  error?: string;
  hideLabel?: boolean;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  [key: string]: unknown; // This allows passing additional props to Input
}

// This input doesn't seem to run validators. If you need ABN validation,
// use a `string` input and `AbnValidator`.
export function AbnInput({
  label,
  title,
  help,
  error,
  hideLabel,
  ...props
}: AbnInputProps) {
  return (
    <WidthContainer>
      <FormControl
        label={label}
        title={title}
        caption={help}
        error={error}
        hideLabel={hideLabel}
      >
        <Input {...props} />
      </FormControl>
    </WidthContainer>
  );
}
